var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SectionHeading from "./SectionHeading";
import TextSkeleton from "../../Skeleton/TextSkeleton";
var SectionHeadingSkeleton = function () {
    return (_jsx(SectionHeading, { title: _jsx(TextSkeleton, { width: "max-w-[150px]", height: "h-3" }), description: _jsxs("div", __assign({ className: "flex flex-col gap-2 mt-2" }, { children: [_jsx(TextSkeleton, { width: "max-w-[600px]" }), _jsx(TextSkeleton, { width: "max-w-[600px]" })] })) }));
};
export default SectionHeadingSkeleton;
